<template>
  <div class="case-container">
    <el-row :gutter="20">
      <!-- 左侧图片区域 -->
      <el-col :span="6">
        <div class="case-image">
          <div class="image-desc">
            <p>AICNOC针对不同行业特性,深入场景,以融合技术与业务需求的解决方案,助力企业的数字化转型和创新业务发展</p>
          </div>
          <img src="../../views/Solution/customercase/image/zb.png" alt="解决方案" />
        </div>
      </el-col>

      <!-- 右侧四栏布局 -->
      <el-col :span="18">
        <el-row>
          <!-- 第一栏：政务行业 -->
          <el-col :span="7">
            <div class="case-section">
              <div class="section-top">政务行业解决方案</div>
              <p class="section-desc">打造政务行业的标准性解决方案</p>
              <div class="case-item">
                <div class="case-icon">
                  <img src="@/assets/zhihui.png" width="24" />
                </div>
                <div class="case-content"  @click="handleCaseClick('/Smartsocialworker/index')" style="cursor: pointer;">
                  <h4>智慧社工服务平台</h4>
                  <p>打造新型"智慧社区"</p>
                </div>
              </div>
              <div class="case-item">
                <div class="case-icon">
                  <img src="@/assets/Engage@2x.png" width="24" />
                </div>
                <div class="case-content" @click="handleCaseClick('/YiLinwz/index')" style="cursor: pointer;">
                  <h4>翼邻微治 - 社群微治理</h4>
                  <p>赋能基层减负解决方案</p>
                </div>
              </div>
            </div>
          </el-col>

          <!-- 第二栏：教育行业 -->
          <el-col :span="7">
            <div class="case-section">
              <div class="section-top">教育行业解决方案</div>
              <p class="section-desc">为教育行业定制精细化解决方案</p>
              <div class="case-item">
                <div class="case-icon">
                  <img src="@/assets/gaoxiao.png" width="24" />
                </div>
                <div class="case-content" @click="handleCaseClick('/smartCampus/index')" style="cursor: pointer;">
                  <h4>高校智慧校园驾驶舱</h4>
                  <p>辅助决策赋能校园治理</p>
                </div>
              </div>
            </div>
          </el-col>

          <!-- 第三栏：通用解决方案 -->
          <el-col :span="7">
            <div class="case-section">
              <div class="section-top">通用解决方案</div>
              <p class="section-desc">适配全行业场景的专业化解决方案</p>
              <div class="case-item case-item-cursor">
                <div class="case-icon">
                  <img src="@/assets/yunwang.png" width="24" />
                </div>
                <div class="case-content" @click="handleCaseClick('/customercase/index')" style="cursor: pointer;">
                  <h4>云网运维专家服务</h4>
                  <p>网络运维服务整体解决方案</p>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { defineEmits } from 'vue';

const emit = defineEmits(['close-dropdown']);
const router = useRouter();

const handleCaseClick = (url) => {
  router.push(url);
  emit('close-dropdown');
};
</script>

<style lang="scss" scoped>
.case-container {
  padding: 20px;
}

.case-section {
  padding: 0 15px;
  text-align: left;
  height: 100%;
  margin-top: 15px;

  &:last-child {
    border-right: none;
  }

  .section-top {
    font-size: 16px;
    margin-bottom: 10px;
    font-weight: 600;
    color: #677489;
    letter-spacing: 0.5px;
    text-transform: uppercase;
  }
}

/* 左侧图片区域样式 */
.case-image {
  position: relative;
  height: 100%;
  padding-right: 15px;
  // width: 220px;
  margin-left: 160px;  /* 向右移动120px */


  img {
    width: 100%;
    height: 180px;
    object-fit: cover;
    border-radius: 4px;
  }
}

.image-desc {
  margin-top: 15px;

  p {
    color: #677489;
    font-family: "PingFang SC";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;
  }
}

.section-desc {
  color: #97a3b7;
  font-family: "PingFang SC";
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.case-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
  cursor: default;
}
.case-item-cursor {
  cursor: pointer;
}

.case-icon {
  margin-right: 10px;
  color: #3366cc;
  flex-shrink: 0;
  width: 24px;
  height: 24px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.case-content {
  margin-bottom: 20px;
  h4 {
    color: #333;
    font-size: 16px;
    margin: 0 0 5px 0;
    white-space: nowrap;
  }

  p {
    color: #666;
    font-size: 14px;
    margin: 0;
  }
}

/* 移动端样式 */
@media (max-width: 768px) {
  /* 只隐藏左侧图片区域 */
  .case-container > .el-row > .el-col:first-child {
    display: none !important;
  }

  /* 右侧内容区域占满宽度 */
  .case-container > .el-row > .el-col:nth-child(2) {
    width: 100% !important;
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }


  /* 放大文字大小 */
  .case-content h4 {
    font-size: 9px !important;
  }
  
  .case-content p {
    font-size: 8px !important;
  }
  .section-top	{
    font-size: 10px !important;
    margin-bottom: 3px !important;
    margin-top: 8px !important;
  }

  .section-desc	{
    font-size: 8px !important;
    margin-bottom: 10px !important;
    white-space: nowrap !important;  /* 防止换行 */
    overflow: hidden !important;     /* 隐藏溢出 */
    text-overflow: ellipsis !important; /* 显示省略号 */
    line-height: 1.2 !important;
  }

  /* 优化案例项目间距 */
  // .case-item {
  //   margin-bottom: 8px !important;
  //   padding: 8px !important;
  // }

  /* 放大图片大小 */
  .case-icon {
    margin-right: 8px !important;
    flex-shrink: 0;
  }

  .case-icon img {
    width: 10px !important;
    height: 10px !important;
  }

  /* 优化案例内容布局 */
  .case-content {
    flex: 1;
    min-width: 0; /* 允许文字收缩 */
  }

  .case-content h4 {
    margin-bottom: 2px !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }

  .case-content p {
    margin: 0 !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }
}
</style>